

































import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Auth from '@/store/modules/auth';
import SignInDialog from '@/components/SignInDialog.vue';
import NotificationMenu from '@/components/NotificationMenu.vue';
import Dialog from '@/store/modules/dialog';
import store from '@/store/store';
import LikersDialog from './LikersDialog.vue';
import ProfileEditDialog from './ProfileEditDialog.vue';
const dialogModule = getModule(Dialog, store);

@Component({
  components: { SignInDialog, NotificationMenu, LikersDialog, ProfileEditDialog },
})
export default class UserMenu extends Vue {
  authModule = getModule(Auth, this.$store);

  get currentUser() {
    return this.authModule.user;
  }

  openSignInDialog() {
    dialogModule.openSignInDialog({ open: true });
  }

  closeSignInDialog() {
    dialogModule.openSignInDialog({ open: false });
  }

  signInWithGoogle() {
    this.authModule.signInWithGoogle();
  }

  signOut() {
    this.authModule.signOut();
  }

  switchLocale(){
    this.$i18n.locale = (this.$i18n.locale === 'ja') ? 'en' : 'ja';
    (<any>this).$moment.locale(this.$i18n.locale);
  }

}
